import React from "react";
import "./newHome.css";
import Layout from "../layout/layout";
import HeroSection from "../Components/heroSection";
import Locations from "../Components/locations";
import About from "../Components/about";
import WhatWeOffer from "../Components/whatWeOffer";

export default function HomePage() {
  return (
    <Layout>
      <HeroSection></HeroSection>
      <About></About>
      <WhatWeOffer></WhatWeOffer>
      <Locations></Locations>
    </Layout>
  );
}
